import { Button, Card, Form, Input } from "antd";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackButtonIcon from "../../../../assets/icons/BackButtonIcon";
import TopCard from "../../../../components/common/TopCard";
import EmployeeFileUpload from "../../../../components/Employees/EmployeeFileUpload";
import KPIAddMoreForm from "../../../../components/KIP/KPIAddMoreForm";
import KPIDetails from "../../../../components/KIP/KPIDetails";
import Loader from "../../../../components/ui/Loader";
import { useGetOwnSingleKpiQuery } from "../../../../features/performanceManagement/performnceManagementApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate } from "../../../../lib/time";
import { findPlanVal } from "../OpenKPISetup/OpenKPISetup";
import {
  planPeriodList,
  planTypeList,
} from "../OpenKPISetup/OpenKPISetupCreate";

export default function KPISetupReportCreate() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { id } = useParams();
  const { isLoading, isError, error, data } = useGetOwnSingleKpiQuery(
    String(id),
    {
      skip: !id,
    }
  );

  useError(isError, error, "Get KPI fail");

  const kpiData = data?.data;

  useEffect(() => {
    if (id) {
      form.setFieldsValue({
        kpiArray: kpiData?.kpiArray,
        attachment: kpiData?.attachment,
        lineManagerComment: kpiData?.lineManagerComment,
      });
    }
  }, [
    form,
    id,
    kpiData?.attachment,
    kpiData?.kpiArray,
    kpiData?.lineManagerComment,
  ]);

  const dueDate = kpiData?.kpi?.departments?.find(
    (el) => el?.departmentId === kpiData?.departmentId
  )?.due_date;

  return (
    <>
      <SidebarLayout
        // title="KPI Setup Report"
        title={kpiData?.kpi?.kpi_title}
      >
        <TopCard
          leftChildren={
            <>
              <Button
                className="normal-dark-button"
                icon={<BackButtonIcon />}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>

              {/* <div className="justify-start text-neutral-700 text-xl font-semibold">
                {kpiData?.kpi?.kpi_title}
              </div> */}
            </>
          }
        >
          {/* <Link to="">
            <Button
              type="primary"
              className="middle-button"
              icon={<SettingIcon />}
            />
          </Link> */}
        </TopCard>

        {isLoading ? (
          <Loader />
        ) : (
          <div>
            <Card>
              <KPIDetails
                department={kpiData?.department?.name}
                designation={kpiData?.designation}
                dueDate={dueDate ? formatDate(dueDate) : undefined}
                employeeId={kpiData?.employee?.employee_id}
                employeeName={kpiData?.employee?.member?.profile?.name}
                lineManageDesignation={kpiData?.lineManager?.role?.name}
                lineManageId={kpiData?.lineManager?.employee_id}
                lineManageName={kpiData?.lineManager?.member?.profile?.name}
                planPeriod={findPlanVal(
                  planPeriodList,
                  String(kpiData?.kpi?.plan_period)
                )}
                planType={findPlanVal(
                  planTypeList,
                  String(kpiData?.kpi?.plan_type)
                )}
                unit={kpiData?.unit}
              />
              <Form
                className="custom-form hide_star_mark"
                requiredMark="optional"
                layout="vertical"
                // onFinish={onFinish}
                size="large"
                form={form}
              >
                <KPIAddMoreForm
                  kpiArray="kpiArray"
                  kpiType="kpiType"
                  weighage="weightage"
                  details="details"
                  disabled
                />

                <div>
                  <div className="self-stretch px-3 py-1.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-2.5 w-full mb-4">
                    <div className="flex justify-start items-center gap-2.5">
                      <div className="justify-start text-slate-600 text-lg font-semibold">
                        Attachment
                      </div>
                    </div>
                  </div>

                  <div className="md:w-[75%]">
                    <Form.Item
                      name="attachment"
                      className="mb-4 md:w-1/2"
                      valuePropName="fileUrl"
                    >
                      <EmployeeFileUpload
                        form={form}
                        accept=".png, .jpg, .jpeg"
                        name="attachment"
                        onChange={(url) =>
                          form.setFieldsValue({
                            attachment: url,
                          })
                        }
                        disabled
                        showImage
                      />
                    </Form.Item>
                  </div>
                </div>

                <div>
                  <div className="self-stretch px-3 py-1.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-2.5 w-full">
                    <div className="flex justify-start items-center gap-2.5">
                      <div className="justify-start text-slate-600 text-lg font-semibold">
                        Line Manager Comment
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between items-end mt-4">
                    <div className="flex items-center gap-3 w-[75%]">
                      <Form.Item
                        name="lineManagerComment"
                        label=""
                        className="w-full"
                        rules={[
                          {
                            required: true,
                            message: "Please enter comment",
                          },
                        ]}
                      >
                        <Input.TextArea
                          className="w-full"
                          size="large"
                          placeholder="Leave your text here"
                          disabled
                        />
                      </Form.Item>
                    </div>

                    <div className="w-[25%] pl-3 mb-6"></div>
                  </div>
                </div>
              </Form>
            </Card>
          </div>
        )}
      </SidebarLayout>
    </>
  );
}
